import { ROOT_PLATFORM_MENU_ID } from '../../constants/apiString'

export const REACT_APP_ROOT_PLATFORM_MENU_ID = ROOT_PLATFORM_MENU_ID
